import { useContext, useEffect, useRef, useState } from 'react'
import Logo from '../assets/logo.png'
import Select from 'react-select'
import { Oval } from 'react-loader-spinner'
import { UploadItem } from '../Pages/Courses/Materials'
import { api } from '../api'
import { path, TOKEN_KEY } from '../constants'
import { appContext } from '../Context/appProvider'
import CancelIcon from '@mui/icons-material/Cancel';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';

const qualificationOptions = [
    {
        label: 'Bachelor’s Degree',
        value: 'degree'
    },
    {
        label: 'Master’s Degree',
        value: 'masters'
    },
    {
        label: 'High School Diploma',
        value: 'hsdiploma'
    },
    {
        label: 'Certificate or Short Course',
        value: 'certificate'
    },
    {
        label: 'Diploma (Technical or Vocational Training)',
        value: 'techdiploma'
    },
    {
        label: 'PhD or Doctorate',
        value: 'phd/doctor'
    },
    {
        label: 'Professional Certification (AWS Certified, Adobe Certified etc..)',
        value: 'professionalcert'
    },
    {
        label: 'Other',
        value: 'other'
    }
]

const findingOptions = [
    {
        label: 'Marketing agents',
        value: 'agents'
    },
    {
        label: 'Social media',
        value: 'social'
    },
    {
        label: 'Google search',
        value: 'google'
    },
    {
        label: 'Word of mouth',
        value: 'word'
    },
    {
        label: 'Referral',
        value: 'referral'
    },
    {
        label: 'Other',
        value: 'other'
    }
]

const instituteOptions = [
    {
        label: 'School',
        value: 'school'
    },
    {
        label: 'College',
        value: 'college'
    },
    {
        label: 'University',
        value: 'university'
    },
    {
        label: 'Training Center',
        value: 'training'
    },
    {
        label: 'Other',
        value: 'other'
    },
]

const audienceOptions = [
    {
        label: 'K - 12 Students',
        value: 'k12'
    },
    {
        label: 'College/University Graduates',
        value: 'graduates'
    },
    {
        label: 'Professionals',
        value: 'professionals'
    },
    {
        label: 'Other',
        value: 'other'
    },
]

export default function BecomeSeller({rejected}){
    const [type, setType] = useState(1)
    const [submitting, setSubmitting] = useState(false)
    const qualificationFileRef = useRef()
    const [qualificationFiles, setQualificationFiles] = useState([])
    const idFileRef = useRef()
    const [idFiles, setIdFiles] = useState([])
    const licenseFileRef = useRef()
    const [licenseFiles, setLicenseFiles] = useState([])
    const [uploading, setUploading] = useState(false)
    const [qualificationSources, setQualificationSources] = useState(null)
    const [idSources, setIdSources] = useState(null)
    const [licenseSources, setLicenseSources] = useState(null)
    const {user, setUser, setToken} = useContext(appContext)
    const [step, setStep] = useState(1)
    const [showTerms, setShowTerms] = useState(false)
    const signout = () => {
        setToken(null)
        localStorage.removeItem(TOKEN_KEY)
    }
    const indFields = [
        'name', 'areaExpertize', 'qualification', 'occupation', 'experience', 'bio', 'finding', 'complete', 'copyright', 'terms'
    ]
    if(!user?.phone) indFields.push('phone')
    const instFields = [
        'name', 'instituteType', 'targetAudience', 'yearEstablished', 'representative', 'address', 'representativePhone', 'finding', 'complete', 'copyright', 'terms'
    ]
    const [errors, setErrors] = useState({show: false, errors: type == 1 ? indFields : instFields})
    const [formData, setFormData] = useState({})

    const checkErrors = (show=false) => {
        
        let missingFields = []
        if(type == 1){
            missingFields = indFields.filter(field => !formData[field])
        } else {
            missingFields = instFields.filter(field => !formData[field])
        }
        if(!qualificationSources && type == 1) missingFields.push('qualificationDoc')
        if(!idSources  && type == 1) missingFields.push('id')
        if(!licenseSources && type == 2) missingFields.push('license')
        setErrors({show, errors: missingFields})
        return missingFields.length
    }

    const submit = () => {
        if(step < 3) return setStep(s => s + 1)
        let err = checkErrors(true)
        if(err) return
        setSubmitting(true)
        let data = {
            type: type == 1 ? 'individual' : 'institute',
        }
        let fields = type == 1 ? indFields : instFields
        fields.forEach(field => {
            data[field] = formData[field]
        })
        if(type == 1){
            data.idDoc = idSources.source
            data.qualificationDoc = qualificationSources.source
        } else data.licenseDoc = licenseSources.source

        api.post(path.applySeller, data).then(response => {
            let data = response.data
            if(data.success){
                setUser(u => ({...u, userStatus: type == 1 ? '1' : '3'}))
            }
        }).finally(() => setSubmitting(false))
    }

    const onChangeQualification = (event) => {
        setQualificationFiles([event.target.files[0]])
    }
    const onChangeID = (event) => {
        setIdFiles([event.target.files[0]])
    }
    const onChangeLicense = (event) => {
        setLicenseFiles([event.target.files[0]])
    }
    console.log(errors, formData)

    useEffect(() => {
        checkErrors(false)
    }, [formData, qualificationSources, idSources, licenseSources, type])


    const updateForm = (key, isSelect=false, isCheckBox=false) => {
        return (event) => {
            setFormData(d => ({
                ...d,
                [key]: isSelect ? event.value : isCheckBox ? event.target.checked : event.target.value
            }))
        }
    }

    return (
        <div className='w-screen h-screen flex flex-col items-center justify-center bg-lightGrey'>
            <div className='bg-white rounded-md shadow-md flex flex-col p-5 w-[400px] items-center gap-1'>
                <img src={Logo} className='w-[60px] object-contain' />
                <p className='text-[16px] text-black'>Apply to Become a Seller </p>
                {rejected && <p className='text-center text-[#ff0000] text-xs'>Your Last Application was rejected please fill appropriate information</p>}
                <div className='flex items-center self-stretch mt-4 gap-2'>
                    <div className='flex flex-col gap-1 flex-1'>
                        <p className='text-sm self-center text-black'>Step 1</p>
                        <div className='bg-main h-[20px] rounded-tr-[20px] rounded-br-[20px]'></div>
                    </div>
                    <div className='flex flex-col gap-1 flex-1'>
                        <p className={`text-sm self-center ${step > 1 && 'opacity-75'}`}>Step 2</p>
                        <div className={`${step > 1 ? 'bg-main' : 'bg-[#00000030]'} h-[20px] rounded-tr-[20px] rounded-br-[20px]`}></div>
                    </div>
                    <div className='flex flex-col gap-1 flex-1'>
                        <p className={`text-sm self-center ${step > 2 && 'opacity-75'}`}>Step 3</p>
                        <div className={`${step > 2 ? 'bg-main' : 'bg-[#00000030]'} h-[20px] rounded-tr-[20px] rounded-br-[20px]`}></div>
                    </div>
                </div>
                <div className='flex flex-col gap-3 w-full mt-4'>
                    {step == 1 ? (
                        <>
                            <div className='flex gap-2 items-center self-center'>
                                <p className='text-lg'>I Am: </p>
                                <div className='border-[1px] border-[black] rounded-[40px] overflow-hidden shadow-lg'>
                                    <button type='button' onClick={() => setType(1)} className={`cursor-pointer hover:bg-[#00000040] px-4 py-1 font-bold border-none ${type == 1 && 'bg-black text-white'}`}>
                                        Individual
                                    </button>
                                    <button type='button' onClick={() => setType(2)} className={`cursor-pointer hover:bg-[#00000040] px-4 py-1 font-bold border-none ${type == 2 && 'bg-black text-white'}`}>
                                        Institute
                                    </button>
                                </div>
                            </div>
                            <input placeholder={type == 1 ? 'Individual Name' : 'Institution Name'} onChange={updateForm('name')} value={formData.name} type='text' className={`mt-4 text-black border-[1px] ${(errors.show && errors.errors.includes('name')) ? 'border-[#ff0000]': 'border-black'} rounded-md p-2 pl-4`}  />
                            {type == 1 ? (
                                <>
                                    <input placeholder='Area of Expertize' type='text' onChange={updateForm('areaExpertize')} value={formData.areaExpertize}  className='mt-4 text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                    <p>Qualification</p>
                                    <Select
                                        options={qualificationOptions}
                                        onChange={updateForm('qualification', true)}
                                        value={qualificationOptions.find(q => q.value == formData.qualification)}
                                    />
                                    <div className='flex gap-2 max-md:flex-col flex-col'>
                                        <p className='text-sm'>Qualification Related Documents (Single PDF/DOCX)</p>
                                        <div className='flex items-center h-[40px]'>
                                            <input ref={qualificationFileRef} onChange={onChangeQualification} type='file' className='border-solid border-[1px] h-full border-[#00000040] w-full p-1' />
                                            <button type='button' onClick={() => qualificationFileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white h-full`}>Change</button>
                                        </div>
                                        {!!qualificationFiles.length && <div className='flex flex-wrap gap-2'>
                                            {qualificationFiles.map(file => (
                                                <UploadItem file={file} setSources={setQualificationSources} sources={qualificationSources} />
                                            ))}
                                        </div> }
                                    </div>
                                </>
                            ) : (
                                <>
                                    <p>Type of Institution</p>
                                    <Select
                                        options={instituteOptions} 
                                        onChange={updateForm('instituteType', true)}
                                        value={instituteOptions.find(q => q.value == formData.instituteType)}
                                    />
                                    <input placeholder='Year Established' onChange={updateForm('yearEstablished')} value={formData.yearEstablished}  type='number' className='mt-4 text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                    <p>Target Audience</p>
                                    <Select
                                        options={audienceOptions}
                                        onChange={updateForm('targetAudience', true)}
                                        value={audienceOptions.find(q => q.value == formData.targetAudience)}
                                    />
                                </>
                            )}
                        </>
                    ) : step == 2 ? (
                        <>
                            {type == 1 ? (
                                <>
                                    {!user?.phone && [
                                        <p className='text-xs font-bold'>Since You don't have phone number connected to your account</p>,
                                        <input placeholder='Phone number' onChange={updateForm('phone')} value={formData.phone} type='text' className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                    ]}
                                    <input placeholder='Current Occupation' onChange={updateForm('occupation')} value={formData.occupation} type='text' className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                    <input placeholder='Teaching Experience (in years)' onChange={updateForm('experience')} value={formData.experience} type='number' className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                    <textarea className='text-black border-[1px] border-black rounded-md p-2 pl-4' onChange={updateForm('bio')} value={formData.bio} cols='2' placeholder='Biography (small description about what you provide)'></textarea>
                                    <div className='flex gap-2 max-md:flex-col flex-col'>
                                        <p className='text-sm'>Proof of ID (Kebele ID, Passport, National ID, Driver License)</p>
                                        <div className='flex items-center h-[40px]'>
                                            <input ref={idFileRef} onChange={onChangeID} type='file' className='border-solid border-[1px] h-full border-[#00000040] w-full p-1' />
                                            <button type='button' onClick={() => idFileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white h-full`}>Change</button>
                                        </div>
                                        {!!idFiles.length && <div className='flex flex-wrap gap-2'>
                                            {idFiles.map(file => (
                                                <UploadItem file={file} setSources={setIdSources} sources={idSources} />
                                            ))}
                                        </div> }
                                    </div>
                                </>
                            ): (
                                <>
                                     <input placeholder='Representative Name' onChange={updateForm('representative')} value={formData.representative} type='text' className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                     <input placeholder='Representative Contact Phone' onChange={updateForm('representativePhone')} value={formData.representativePhone} type='number' className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                     <input placeholder='Address' type='text' onChange={updateForm('address')} value={formData.address}  className='text-black border-[1px] border-black rounded-md p-2 pl-4'  />
                                     <div className='flex gap-2 max-md:flex-col flex-col'>
                                        <p className='text-sm'>Trade License Documents (Single PDF/DOCX)</p>
                                        <div className='flex items-center h-[40px]'>
                                            <input ref={licenseFileRef} onChange={onChangeLicense} type='file' className='border-solid border-[1px] h-full border-[#00000040] w-full p-1' />
                                            <button type='button' onClick={() => licenseFileRef.current?.click()} className={`bg-black p-2 text-[12px] text-white h-full`}>Change</button>
                                        </div>
                                        {!!licenseFiles.length && <div className='flex flex-wrap gap-2'>
                                            {licenseFiles.map(file => (
                                                <UploadItem file={file} setSources={setLicenseSources} sources={licenseSources} />
                                            ))}
                                        </div> }
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                             <p>How did you hear about us?</p>
                            <Select
                                options={findingOptions}
                                onChange={updateForm('finding', true)}
                                value={findingOptions.find(q => q.value == formData.finding)}
                            />
                            <div>
                                <input type='checkbox' id="complete" onChange={updateForm('complete', false, true)} checked={formData.complete} />
                                <label for="complete"> I confirm that all the information provided above is accurate and complete.</label>
                            </div>
                            <div>
                                <input type='checkbox' id="upload" onChange={updateForm('copyright', false, true)} checked={formData.copyright} />
                                <label for="upload">  I confirm that I own the rights to all content I upload.</label>
                            </div>
                            <div>
                                <input type='checkbox' id="terms" onChange={updateForm('terms', false, true)} checked={formData.terms} />
                                <label for="terms"> I agree to the <button onClick={() => setShowTerms(true)} className='text-[#0000ff] underline'>terms and conditions </button> </label>
                            </div>
                        </>
                    )}
                    {step == 3 && (!!errors.errors.length) && <p className='text-[#ff0000] text-sm text-center'>Make sure to fill all fields and enable checkboxes</p>}
                    <div className='flex items-center mt-4' style={{
                        flexDirection: step > 1 ? 'row-reverse' : 'row',
                        justifyContent: step > 1 ? 'space-between' : 'end'
                    }}>
                        <button disabled={submitting || (errors.errors.length && step == 3)} onClick={submit}  className={`text-white text-[20px] rounded-md py-2 px-4 flex items-center justify-center ${(errors.errors.length && step == 3) ? 'bg-[#00000060]' : 'bg-main'}`} type='submit'>
                        {submitting ? (
                            <Oval
                            visible={true}
                            height="30"
                            width="30"
                            color="#ffffff"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                            />
                        ) : step < 3 ? 'Next' : 'Submit'}
                        </button>

                        {step  > 1 && <button onClick={() => setStep(s => s - 1)} className='bg-main text-white text-[20px] rounded-md p-2 flex items-center justify-center' type='submit'>
                            Back
                        </button> }
                    </div>
                </div>
            </div>
            <button onClick={signout} className='text-main underline text-sm mt-1'>Sign out</button>
            {showTerms && <Terms show={setShowTerms} />}
        </div>
    )
}

export function Terms({ show }){
    return (
        <div className='fixed bg-[#00000080] inset-0 flex justify-center p-10 max-md:p-1 max-md:pt-4 z-[99999]'>
            <div className='rounded-md bg-white p-4 flex flex-col gap-4 relative w-[80%] max-md:w-[95%]'>
                <button className='absolute top-[-15px] bg-white rounded-full right-[-15px] flex items-center justify-center' onClick={() => show(false)}>
                    <CancelIcon style={{fontSize: 30, color: '#000000'}}>Filled</CancelIcon>
                </button>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    <Viewer fileUrl={require('../assets/terms.pdf')} />;
                </Worker>
            </div>
        </div>
    )
}